module.exports = __webpack_public_path__ + "media/r_kv.d5f9ca85.mp4";